
(() => {
  'use strict';

  // --- Constantes reprises de ta link-bar (pour le même feeling) ---
  const mql = window.matchMedia('(max-width: 749px)');
  const isMobile = () => mql.matches;

  const SPRING_STIFFNESS = 300;
  const SPRING_DAMPING   = 2 * Math.sqrt(SPRING_STIFFNESS);
  const MAX_DT           = 0.050;
  const PIX_SNAP_DPR     = (window.devicePixelRatio || 1);
  const STOP_EPS         = 0.02;

  const THUMB_SCALE = 0.4;
  const MIN_THUMB   = 8;

  // --- Helper ---
  const hasOverflowX = (el) => el && (el.scrollWidth - el.clientWidth) > 1;

  // --- Initialisation sur tous les conteneurs marqués ---
  function initAll() {
    document.querySelectorAll('[data-progress="linkbar"]').forEach(setupOne);
  }

  function setupOne(scrollEl) {
    if (scrollEl.__lbp) return; // déjà initialisé

    const itemSel = scrollEl.getAttribute('data-item') || '> *';
    const getItems = () => scrollEl.querySelectorAll(itemSel);

    // Injecte le track + thumb si absent (mêmes classes -> même look)
    let track = scrollEl.querySelector(':scope > .linkbar-full-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'linkbar-full-track';
      const thumb = document.createElement('div');
      thumb.className = 'linkbar-progress-thumb';
      track.appendChild(thumb);
      scrollEl.appendChild(track);
    }
    const thumb = track.querySelector('.linkbar-progress-thumb');

    // État / métriques
    let metrics = null;
    let animId = null, currentX = 0, velocity = 0, targetX = 0, lastT = 0;
    let roScroller = null, roList = null;

    function computeMetrics(){
      metrics = null;

      const els = getItems();
      if (!els.length) {
        track.style.opacity = '0';
        return;
      }

      const cRect = scrollEl.getBoundingClientRect();
      const fRect = els[0].getBoundingClientRect();
      const lRect = els[els.length - 1].getBoundingClientRect();

      const startX = fRect.left  - cRect.left + scrollEl.scrollLeft;
      const endX   = lRect.right - cRect.left + scrollEl.scrollLeft;
      const width  = Math.max(0, endX - startX);

      const clientWidth = scrollEl.clientWidth;
      const scrollWidth = scrollEl.scrollWidth;

      const ratio  = Math.pow(clientWidth / Math.max(scrollWidth, 1), 0.8);
      const thumbW = Math.max(MIN_THUMB, ratio * width * THUMB_SCALE);

      metrics = { startX, width, clientWidth, scrollWidth, thumbW };

      track.style.left  = startX + 'px';
      track.style.width = width  + 'px';
      thumb.style.width = thumbW + 'px';

      const can = hasOverflowX(scrollEl);
      track.style.opacity = can ? '1' : '0';
    }

    function updateThumbTargetOnly(){
      if (!metrics) return;

      const { clientWidth, scrollWidth, width, thumbW } = metrics;
      const sLeft   = scrollEl.scrollLeft;
      const maxScr  = Math.max(0, scrollWidth - clientWidth);
      const prog    = maxScr ? (sLeft / maxScr) : 0;
      const rawX    = prog * Math.max(0, width - thumbW);

      targetX = Math.round(rawX * PIX_SNAP_DPR) / PIX_SNAP_DPR;
    }

    function tick(now = performance.now()){
      if (!thumb){ animId = requestAnimationFrame(tick); return; }
      if (!isMobile()){ // sur desktop, on masque (même logique que ta link-bar)
        track.style.opacity = '0';
        animId = requestAnimationFrame(tick);
        return;
      }

      if (!lastT) lastT = now;
      let dt = (now - lastT) / 1000;
      if (dt > MAX_DT) dt = MAX_DT;
      lastT = now;

      const a = -SPRING_STIFFNESS * (currentX - targetX) - SPRING_DAMPING * velocity;
      velocity += a * dt;
      currentX += velocity * dt;

      const snapped = Math.round(currentX * PIX_SNAP_DPR) / PIX_SNAP_DPR;
      thumb.style.transform = `translate3d(${snapped}px,0,0)`;

      const nearTarget = Math.abs(targetX - currentX) < STOP_EPS;
      const slow       = Math.abs(velocity) < STOP_EPS;
      if (nearTarget && slow) {
        currentX = targetX;
        velocity = 0;
        thumb.style.transform = `translate3d(${Math.round(targetX * PIX_SNAP_DPR)/PIX_SNAP_DPR}px,0,0)`;
      }

      animId = requestAnimationFrame(tick);
    }

    function onScroll(){
      updateThumbTargetOnly();
    }

    function onResizeOrListChange(){
      computeMetrics();
      updateThumbTargetOnly();
    }

    function bind(){
      scrollEl.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', onResizeOrListChange, {passive:true});
      if ('ResizeObserver' in window){
        roScroller = new ResizeObserver(onResizeOrListChange);
        roScroller.observe(scrollEl);
        const listEl = scrollEl; // le contenu change dans ce conteneur
        roList = new ResizeObserver(onResizeOrListChange);
        roList.observe(listEl);
      }
      computeMetrics();
      updateThumbTargetOnly();
      if (!animId) requestAnimationFrame(tick);
    }

    function unbind(){
      try{ scrollEl.removeEventListener('scroll', onScroll, {passive:true}); }catch(e){}
      try{ window.removeEventListener('resize', onResizeOrListChange, {passive:true}); }catch(e){}
      try{ roScroller?.disconnect(); }catch(e){}
      try{ roList?.disconnect(); }catch(e){}
      if (animId) cancelAnimationFrame(animId);
      animId = null; lastT = 0;
    }

    // Expose pour debug si besoin
    scrollEl.__lbp = { recompute: onResizeOrListChange, destroy: unbind };

    // Mobile only (comme ton script)
    const start = () => { unbind(); if (isMobile()) bind(); else track.style.opacity = '0'; };
    start();
    mql.addEventListener('change', start, {passive:true});
    window.addEventListener('load', () => setTimeout(onResizeOrListChange, 200), { once:true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once:true });
  } else {
    initAll();
  }

  // si des blocs arrivent dynamiquement
  new MutationObserver(muts => {
    for (const m of muts){
      for (const n of m.addedNodes||[]){
        if (n.nodeType===1 && (n.matches?.('[data-progress="linkbar"]') || n.querySelector?.('[data-progress="linkbar"]'))){
          initAll(); return;
        }
      }
    }
  }).observe(document.documentElement, { childList:true, subtree:true });
})();
